module.exports = __webpack_public_path__ + "img/lisa_h_3.ce306d24.png";